import { TrainingOffering, TrainingOfferingCategory } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { TrainingOfferingData } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { assertNever } from '../../../../../util/types';
import { ListEntryWithIdentity } from '../../../common/list/list-types';
import { ListFieldInfo } from '../../../common/list/list-types';

export type TrainingOfferingListEntry = ListEntryWithIdentity<TrainingOffering>;

export const TrainingOfferingListView: ListFieldInfo<TrainingOfferingListEntry, TrainingOfferingData>[] = [
  {
    name: 'title',
    label: 'Title',
    kind: 'link',
    displayed: true,
    sortable: true,
    searchable: true,
  },
  {
    name: 'duration',
    label: 'Duration',
    kind: 'text',
    displayed: false,
    sortable: false
  },
  {
    name: 'executeUrl',
    label: 'Target URL',
    kind: 'text',
    displayed: true,
    sortable: false,
    maxWidth: 'Medium',
  },
  {
    name: 'tileUrl',
    label: 'Image',
    kind: 'img',
    displayed: false
  },
  {
    name: 'category',
    label: 'Category',
    kind: 'mapped',
    map: entry => entryCategory(entry),
    displayed: true,
    sortable: true,
    searchable: true,
    searchOption: (entry) => {
      return { label: entryCategory(entry), value: entry.category};
    },
    filterField: 'category',  
  },
  {
    name: 'providerName',
    label: 'Learning Provider',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const lp = data.learningProviders.find(item => entry.providerId === item.id);
        if (lp) {
          return lp.value.name;
        }
      }
      return 'notfound';
    },
    displayed: true,
    sortable: true,
    searchable: true,
    searchOption: (entry, data) => {
      if (data) {
        const lp = data.learningProviders.find(item => entry.providerId === item.id);
        if (lp) {
          return { label: lp.value.name, value: lp.id };
        }
      }
      return undefined;
    },
    filterField: 'providerId',  
  },
  {
    name: 'skillCount',
    label: 'No. Skills',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        return data.availableSkills.filter(sto => sto.value.trainingOfferingId === entry.id).length||'';
      }
      return '';
    },
    displayed: true,
    sortable: true,
  },
  {
    name: 'skillTrainingOfferings',
    label: 'Skills',
    kind: 'selectList',
    map: (entry, data) => {
      if (data) {
        const stos = data.availableSkills.filter(sto => sto.value.trainingOfferingId === entry.id);
        const options = stos
          .map(sto => {
          const skill = data.skills.find(sk => sk.id === sto.value.skillId);
          return { label: skill ? skill.value.name.value.en : 'notfound', value: sto.value.skillId };
        });
        return options.length === 0 ? [{ label: 'None', value: '' }] : options;
      }
      return [{ label: 'notfound', value: '' }];
    },
    displayed: true
  },
  {
    name: 'competencies',
    label: 'Competencies',
    kind: 'selectList',
    map: (entry, data) => {
      if (data) {
        const ctos = data.availableCompetencies.filter(cto => cto.value.trainingOfferingId === entry.id);
        const options = ctos.map(cto => {
          const competency = data.competencies.find(c => c.id === cto.value.competencyId);
          return { label: competency ? competency.value.name.value.en : 'notfound', value: cto.value.competencyId };
        });
        return options.length === 0 ? [{ label: 'None', value: '' }] : options;
      }
      return [{ label: 'notfound', value: '' }];
    },
    displayed: false
  },
  {
    name: 'catalogEntry',
    label: 'Catalog Entry',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const catEntry = data.catalog.find(e => e.id === entry.catalogEntryId);
        if (catEntry) {
          return catEntry.value.courseId;
        }
        return 'None';
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false
  },
  {
    name: 'description',
    label: 'Description',
    // TODO: markdown
    kind: 'text',
    displayed: false,
    sortable: false
  }
];

const entryCategory = (entry: TrainingOfferingListEntry) => {
      switch (entry.category) {
        case TrainingOfferingCategory.elearning:
          return 'Self-Paced';
        case TrainingOfferingCategory.face2face:
          return 'Face to Face';
        case TrainingOfferingCategory.virtual:
          return 'Virtual';
        default:
          assertNever(entry.category, 'Category not found');
          return '';
      }
    };


// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/training-offering-lists/training-offering-list-view.ts